import icons from '@loggi/ui/components/utils/icons';
import PropTypes from 'prop-types';
import React from 'react';
import DisplayData from 'shared/display-data/display-data.component';
import {
  DESCRIPTION_BUTTON_ID,
  DESCRIPTION_LABEL_TEXT
} from './destination-description.constants';

export default function DestinationDescription({
  descriptionData,
  onClick,
  hasDivider
}) {
  const buttonIcon = descriptionData ? icons.type.EDIT : icons.type.ADD;

  return (
    <DisplayData
      hasDivider={hasDivider}
      label={DESCRIPTION_LABEL_TEXT}
      mainData={descriptionData}
      icon={icons.type.GPS_ARROW}
      actionButton={{
        icon: buttonIcon,
        click: onClick,
        dataTestid: DESCRIPTION_BUTTON_ID
      }}
    />
  );
}

DestinationDescription.displayName = 'DestinationDescription';
DestinationDescription.propTypes = {
  onClick: PropTypes.func.isRequired,
  descriptionData: PropTypes.string,
  hasDivider: PropTypes.bool
};
DestinationDescription.defaultProps = {
  descriptionData: null,
  hasDivider: false
};
